
import React, { useEffect, useState } from 'react';
import BoxWrapper from '../../components/ui/boxWrapper';
import TextField from '@mui/material/TextField';
import AddIcon from '@mui/icons-material/Add';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,

} from '@mui/material';
import Grid from '@mui/material/Grid';
import EditIcon from '@mui/icons-material/Edit';
import axios from "../../axios-order";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { Delete } from '@mui/icons-material';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import ToggleSwitch from '../../components/ui/ToggleSwitch/ToggleSwitch';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

const apiUrl = process.env.REACT_APP_BACKEND_BASE_URL;

function Createcompany({  }) {
  const [formValues, setFormValues] = useState({
    supplierGstin: '',
    tradeName: '',
    entitytype:'',
    supplierAddress2: '',
    phoneNumber: '',
    legalName: '',
    supplierAddress1: '',
    supplierLocation: '',
    pinCode: '',
    emailId: '',
    state: '', 
  });

  const [image, setImage] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [isClearClicked, setIsClearClicked] = useState(false); 
  const [supplierData, setSupplierData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [fetchCount, setFetchCount] = useState(0);
  const [showUploadHistoryTable, setShowUploadHistoryTable] = useState(false);
  const [open, setOpen] = useState(false);
  const [currentRowId, setCurrentRowId] = useState(null);
  const [validationErrors,setValidationErrors] = useState([]);
  const [supplierId, setSupplierId] = useState(null);
  const [supplierChildData, setSupplierChildData] = useState([]);
  const [errors, setErrors] = useState({
    bank_name: false,
    account_number: false,
    ifsc_code: false,
    account_holder_name: false,
  });
  const [bankDetails, setBankDetails] = useState({
    bank_name: '',
    account_number: '',
    ifsc_code: '',
    account_holder_name: ''
  });
  const [isDialogOpen, setDialogOpen] = useState(false); 
  const [formData, setFormData] = useState({
    legalName: '',
    location: '',
    pincode: '',
    address1: '',
    address2: '',
    state: '',
  });
  const [isEditModeline, setIsEditModeline] = useState(false);
  const handlelineInputChange = (event) => {
    const { name, value } = event.target;
    console.log("name",name);
    console.log("value",value);
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleAdd = (id) => {
    const selectedRow = supplierData.find((row) => row.id === id);
    if (selectedRow) {
      setFormData({
        legalName: selectedRow.supplier_legal_name || '',
      });
    }
    
  setDialogOpen(true);  
  setCurrentRowId(id);
  
  axios.get(`/einvoice/get_supplier_child/${id}/`)
  .then(response =>{
    if (response.data && response.data.records) {
      setSupplierChildData(response.data.records); 
    }
  })
  .catch(error => {
    console.log(error)
  })
};

  const handlelineClose = () => {
    setFormData({
   
      location: '',
      pincode: '',
      address1: '',
      address2: '',
      state: '',
    });
    setValidationErrors([]);
    setSupplierChildData([])
    setDialogOpen(false); 
  };
  
  const handleEditline = (row) => {
    const matchedState = stateschild.find(
      (state) => state.name.toLowerCase().trim() === row.supplier_child_state.toLowerCase().trim()
    );
  
    setFormData({
      gstin: row.gstin || '',
      location: row.supplier_child_location || '',
      pincode: row.supplier_child_pincode || '',
      address1: row.supplier_child_address_one || '',
      address2: row.supplier_child_address_two || '',
      state: matchedState ? matchedState.name : '',
    });
  
    setCurrentRowId(row.id);
    setIsEditModeline(true);
  };
  
  
  
  

  const handleSubmitline = (id) => {
    const requiredFields = ['location', 'pincode', 'address1', 'state'];
  const missingFields = requiredFields.filter((field) => !formData[field]);

  if (missingFields.length > 0) {
    setValidationErrors(missingFields);
    return;
  }
    const payload = {
      supplier_master_id: id,
      supplier_location: formData.location,
      supplier_pincode: formData.pincode,
      supplier_address_one: formData.address1,
      supplier_address_two: formData.address2,
      supplier_state: formData.state,
    };

    if (isEditModeline) {
   
      payload.id = currentRowId;
    }
  
    const url = isEditModeline ? '/einvoice/update_supplier_child' : '/einvoice/post_supplier_additional_address';
    axios.post(url, payload)
      .then((response) => {
        console.log(response);
        fetchData();
        setDialogOpen(false);
        setIsEditModeline(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

    const handleClickOpen = () => {
      setOpen(true);
    };
  



 
    const handleClose = () => {
      setOpen(false);
      setErrors({
        bank_name: false,
        account_number: false,
        ifsc_code: false,
        account_holder_name: false,
      });
      fetchBankDetails();
    
    };

     
  const handleChange = (e) => {
    const { name, value } = e.target;
    setBankDetails((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleIFSCChange = (e) => {
    const { value } = e.target;

  
    const letters = value.match(/[A-Za-z]/g) || [];
    const numbers = value.match(/[0-9]/g) || [];

    const lettersCount = letters.length;
    const numbersCount = numbers.length;

    
    if (lettersCount <= 4 && numbersCount <= 7 && value.length <= 11) {
        setBankDetails((prevState) => ({
            ...prevState,
            ifsc_code: value 
        }));
     
        setErrors((prev) => ({ ...prev, ifsc_code: false }));
    } else {
      
        if (lettersCount > 4 || numbersCount > 7) {
      
            setErrors((prev) => ({ ...prev, ifsc_code: true }));
        }
    }
};






 

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const states = [
    { code: 'AP', name: 'Andhra Pradesh' },
    { code: 'AR', name: 'Arunachal Pradesh' },
    { code: 'AS', name: 'Assam' },
    { code: 'BR', name: 'Bihar' },
    { code: 'CT', name: 'Chhattisgarh' },
    { code: 'GA', name: 'Goa' },
    { code: 'GJ', name: 'Gujarat' },
    { code: 'HR', name: 'Haryana' },
    { code: 'HP', name: 'Himachal Pradesh' },
    { code: 'JH', name: 'Jharkhand' },
    { code: 'KA', name: 'Karnataka' },
    { code: 'KL', name: 'Kerala' },
    { code: 'MP', name: 'Madhya Pradesh' },
    { code: 'MH', name: 'Maharashtra' },
    { code: 'MN', name: 'Manipur' },
    { code: 'ML', name: 'Meghalaya' },
    { code: 'MZ', name: 'Mizoram' },
    { code: 'NL', name: 'Nagaland' },
    { code: 'OR', name: 'Odisha' },
    { code: 'PB', name: 'Punjab' },
    { code: 'RJ', name: 'Rajasthan' },
    { code: 'SK', name: 'Sikkim' },
    { code: 'TN', name: 'Tamil Nadu' },
    { code: 'TG', name: 'Telangana' },
    { code: 'TR', name: 'Tripura' },
    { code: 'UP', name: 'Uttar Pradesh' },
    { code: 'UT', name: 'Uttarakhand' },
    { code: 'WB', name: 'West Bengal' },
    { code: 'AN', name: 'Andaman and Nicobar Islands' },
    { code: 'CH', name: 'Chandigarh' },
    { code: 'DH', name: 'Dadra and Nagar Haveli and Daman and Diu' },
    { code: 'DL', name: 'Delhi' },
    { code: 'JK', name: 'Jammu and Kashmir' },
    { code: 'LA', name: 'Ladakh' },
    { code: 'LD', name: 'Lakshadweep' },
    { code: 'PY', name: 'Puducherry' },
    { code: 'NT', name: 'Other Territory' },
    { code: 'OC', name: 'Other Country' }
  ];
  
  const entityTypes = ["Head Office", "Branch"];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handlePhoneChange = (e) => {
    const { name, value } = e.target;
  
  
    if (/^\d*$/.test(value) && value.length <= 10) {
      setFormValues({
        ...formValues,
        [name]: value,
      });
    }
  };
  const handlePinChange = (e) => {
    const { name, value } = e.target;
    
  
    if (/^\d{0,6}$/.test(value)) {
      setFormValues({
        ...formValues,
        [name]: value,
      });
    }
  };

  const stateschild = [
    { code: 'AP', name: 'Andhra Pradesh' },
    { code: 'AR', name: 'Arunachal Pradesh' },
    { code: 'AS', name: 'Assam' },
    { code: 'BR', name: 'Bihar' },
    { code: 'CT', name: 'Chhattisgarh' },
    { code: 'GA', name: 'Goa' },
    { code: 'GJ', name: 'Gujarat' },
    { code: 'HR', name: 'Haryana' },
    { code: 'HP', name: 'Himachal Pradesh' },
    { code: 'JH', name: 'Jharkhand' },
    { code: 'KA', name: 'Karnataka' },
    { code: 'KL', name: 'Kerala' },
    { code: 'MP', name: 'Madhya Pradesh' },
    { code: 'MH', name: 'Maharashtra' },
    { code: 'MN', name: 'Manipur' },
    { code: 'ML', name: 'Meghalaya' },
    { code: 'MZ', name: 'Mizoram' },
    { code: 'NL', name: 'Nagaland' },
    { code: 'OR', name: 'Odisha' },
    { code: 'PB', name: 'Punjab' },
    { code: 'RJ', name: 'Rajasthan' },
    { code: 'SK', name: 'Sikkim' },
    { code: 'TN', name: 'Tamil Nadu' },
    { code: 'TG', name: 'Telangana' },
    { code: 'TR', name: 'Tripura' },
    { code: 'UP', name: 'Uttar Pradesh' },
    { code: 'UT', name: 'Uttarakhand' },
    { code: 'WB', name: 'West Bengal' },
    { code: 'AN', name: 'Andaman and Nicobar Islands' },
    { code: 'CH', name: 'Chandigarh' },
    { code: 'DH', name: 'Dadra and Nagar Haveli and Daman and Diu' },
    { code: 'DL', name: 'Delhi' },
    { code: 'JK', name: 'Jammu and Kashmir' },
    { code: 'LA', name: 'Ladakh' },
    { code: 'LD', name: 'Lakshadweep' },
    { code: 'PY', name: 'Puducherry' },
    { code: 'NT', name: 'Other Territory' },
    { code: 'OC', name: 'Other Country' }
  ];


  const handleSupplierlocation = (e) => {
    const { name, value } = e.target;

  if (/^[A-Za-z\s]*$/.test(value)) {
    setFormValues({
      ...formValues,
      [name]: value,
    });
  }

  }
  

  const handleClear = () => {
    setIsEditMode(false);
    setFormValues({
     
      tradeName: '',
      entitytype:'',
      supplierAddress2: '',
      phoneNumber: '',
     supplierGstin:formValues.supplierGstin,
     legalName:formValues.legalName,
     emailId:'',
      supplierAddress1: '',
      supplierLocation: '',
      pinCode: '',
     
      state: '', 
    });
  
    setIsClearClicked(true);
    setImage(null);
  };

  
 
  const fetchData = async () => {
   
    let isMounted = true;
  
    
    
    const gstin = localStorage.getItem('gst');
    const entityName = localStorage.getItem('entity_name');
    const contactNumber = localStorage.getItem('contact_number');
    const emailId = localStorage.getItem('contact_email_id');
    const entityAddress = localStorage.getItem('Entity_Address');
    const businessEntityId = localStorage.getItem('business_entity_id');
  

    setFormValues(prevValues => ({
      ...prevValues,
      supplierGstin: gstin || '',
      legalName: entityName || '',
      emailId: emailId || '',
      phoneNumber: contactNumber || '',
      supplierAddress1: entityAddress || '',
    }));
  
    if (businessEntityId) {
      try {

        const completeEntityResponse = await axios.get(`/get_complete_entity_data/${businessEntityId}`);
        const completeEntityData = completeEntityResponse.data;
  
        if (isMounted) {
          localStorage.setItem('contact_number', completeEntityData.Entity.contact_number);
          localStorage.setItem('Entity_Address', completeEntityData.Entity.entity_address);
          localStorage.setItem('contact_email_id', completeEntityData.Entity.contact_email_id);
  
          setFormValues(prevValues => ({
            ...prevValues,
            supplierGstin: completeEntityData.gstin || prevValues.supplierGstin,
            legalName: completeEntityData.entityName || prevValues.legalName,
            emailId: completeEntityData.emailId || prevValues.emailId,
            phoneNumber: completeEntityData.contactNumber || prevValues.phoneNumber,
            supplierAddress1: completeEntityData.entityAddress || prevValues.supplierAddress1,
       
          }));
        }
  

        const supplierResponse = await axios.get(`/einvoice/get_supplier_master/${businessEntityId}/`);
        if (supplierResponse.data.status) {
          if (isMounted) {
            setSupplierData(supplierResponse.data.records);
            setSupplierId(supplierResponse.data.records[0].id); 
          }
        } else {
          throw new Error(supplierResponse.data.message);
        }
        await fetchBankDetails(businessEntityId); 
      } catch (error) {
        console.error('Error fetching data:', error);
        setError(error.message);
      } finally {
        setLoading(false);
       
   
      }

    } else {
      setLoading(false);
    }
  
    return () => {
      isMounted = false;
    };
  };
  
  const fetchBankDetails = async () => {
    try {
      const businessEntityId = localStorage.getItem('business_entity_id') 
        const response = await axios.get(`/einvoice/get_supplier_bank_info/${businessEntityId}`);
        

        if (response.data && response.data.status) {
            const records = response.data.records; 

        
            const newBankDetails = {
                bank_name: records.bank_name || '',
                account_number: records.account_number || '',
                ifsc_code: records.ifsc_code || '',
                account_holder_name: records.account_holder_name || ''
            };

            setBankDetails(newBankDetails);
           
        }
    } catch (error) {
        console.error('Error fetching bank details:', error);
    }
};



useEffect(() => {
    console.log("Current Bank Details State:", bankDetails);
}, [bankDetails]); 

  useEffect(() => {
   
    fetchData();
    
 
    const timer = setTimeout(() => {
      setFetchCount(prevCount => prevCount + 1);
    }, 1000);

    
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
  
    if (fetchCount === 1) {
      fetchData();
    }
  }, [fetchCount]);


 

  const handleSubmit = (e) => {
    e.preventDefault();

    const { tradeName, supplierLocation, pinCode, state , phoneNumber ,entitytype} = formValues;

    if (!tradeName || !supplierLocation || !pinCode || !state ||  !entitytype) {
      setSnackbarMessage("Please Enter Mandatory Fields");
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      return;
    }

    

  const phoneNumberStr = String(phoneNumber).trim();
  if (phoneNumberStr && !/^\d{10}$/.test(phoneNumberStr)) {
    setSnackbarMessage("Phone number must be 10 digits");
    setSnackbarSeverity('error');
    setSnackbarOpen(true);
    return;
  }
    const pinCodeStr = String(pinCode);
    if (!/^\d{6}$/.test(pinCodeStr)) {
      setSnackbarMessage("Pin code must be  6 digits");
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      return;
    }
    
   
    const businessEntityId = localStorage.getItem('business_entity_id');
  
    const payload = {
      supplierId:supplierId,
      business_entity_id:businessEntityId,
      gstin: formValues.supplierGstin,
      legal_name: formValues.legalName,
      trade_name: formValues.tradeName,
      entitytype:formValues.entitytype,
      address_one: formValues.supplierAddress1,
      address_two: formValues.supplierAddress2,
      location: formValues.supplierLocation,
      state: formValues.state,
      pincode: formValues.pinCode,
      email: formValues.emailId,
      phone:  phoneNumberStr || '',
      company_logo: image || '',
    };

    const url = isEditMode
    ? `/einvoice/post_supplier_master` 
    : `/einvoice/post_supplier_master`; 

  const method = isEditMode ? 'post' : 'post';
  
  axios[method](url, payload)
      .then(response => response.data)
      .then(data => {
        
        if (data.status) {
          setSnackbarMessage(data.message);
      
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          
        setFormValues(prevValues => ({
          ...prevValues,
          tradeName: '',
          entitytype:'',
          supplierLocation: '',
          supplierAddress2: '',
          pinCode: '',
          state: '',
        }));
          fetchData();
          handleToggleChange({ target: { checked: false } });
        }
     
        
      } )
      .catch((error) => {
        console.error('Error:', error);
     
      
  
      
        let errorMessage = 'Error Uploading data';
      
        
        if (error.response) {
   
          errorMessage = error.response.data.message || errorMessage;
        } else if (error.message) {
       
          errorMessage = error.message;
        }
      

        setSnackbarMessage(errorMessage);
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      });
  
  };
  

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith('image/')) {
        

    if (file.size > 1 * 1024 * 1024) {
      setSnackbarMessage('File size exceeds 1MB. Please upload a smaller file.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true); 
      return; 
    }

      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result;
        setImage(base64String); 
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      // alert('Please upload a valid image file.');
    }
  };

  const handleRemoveImage = () => {
    
  setImagePreview(null); 
    setImage(null); 
  };

  const handleEdit = (row) => {
    setIsEditMode(true);
    setSupplierId(row.id);
    console.log("Row id",row.id);
    handleToggleChange({ target: { checked: true } }, row.id);

    setFormValues({
      supplierGstin: row.supplier_gstin,
      tradeName: row.supplier_trade_name,
      entitytype:row.supplier_entity_type,
      supplierAddress2: row.supplier_address_two,
      phoneNumber: row.supplier_phone,
      legalName: row.supplier_legal_name,
      supplierAddress1: row.supplier_address_one,
      supplierLocation: row.supplier_location,
      pinCode: row.supplier_pincode,
      emailId: row.supplier_email,
      state: row.supplier_state,
    });

  if (row.supplier_company_logo) {
    setImagePreview(`data:image/png;base64,${row.supplier_company_logo}`);
    setImage(`data:image/png;base64,${row.supplier_company_logo}`);
  }
  };
  const handleToggleChange = (event, supplierId = null) => {
    if (!event.target.checked) {
      setSupplierId(null);
      setIsEditMode(false);
      setImage(null);
    } else {
      setSupplierId(supplierId); 
    }
  
    setShowUploadHistoryTable(!showUploadHistoryTable);
    if (!showUploadHistoryTable) {
      setFormValues({
        tradeName: '',
        entitytype: '',
        supplierAddress2: '',
        phoneNumber: '',
        supplierGstin: formValues.supplierGstin,
        legalName: formValues.legalName,
        emailId: '',
        supplierAddress1: '',
        supplierLocation: '',
        pinCode: '',
        state: '',
      });
    }
  };


  
 
const handleaddBankInfo = () => {
  const business_entity_id = localStorage.getItem('business_entity_id');

 
  const newErrors = {
      bank_name: !bankDetails.bank_name,
      account_number: !bankDetails.account_number,
      ifsc_code: !bankDetails.ifsc_code || bankDetails.ifsc_code.length !== 11,
      account_holder_name: !bankDetails.account_holder_name,
  };

  if (newErrors.ifsc_code) {
    setSnackbarMessage('IFSC code must be exactly 11 characters long.');
    setSnackbarSeverity('error');
    setSnackbarOpen(true);
  }

  setErrors(newErrors);


  if (Object.values(newErrors).some((error) => error)) {
      return; 
  }

 
  axios.post('/einvoice/add_supplier_bank_info', {
      business_entity_id: business_entity_id,
      supplier_id: supplierId,
      bank_name: bankDetails.bank_name,
      account_number: bankDetails.account_number,
      ifsc_code: bankDetails.ifsc_code,
      account_holder_name: bankDetails.account_holder_name,
  })
  .then((response) => {

    setSnackbarMessage(response?.data?.message);
    setSnackbarSeverity('success');
    setSnackbarOpen(true);

    
      setOpen(false);
  })
  .catch((error) => {
    
      console.error('Error submitting bank details:', error);
      setSnackbarMessage(error?.response?.data?.message);
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
  });
};

  
  
  return (
    <div>
         <div>
        <ToggleSwitch
         id="toggleUploadRecipient"  
          onChange={handleToggleChange}
          value={showUploadHistoryTable}
          label="Add Company Details"
         
        />
       
      </div>
      {showUploadHistoryTable && (
      <BoxWrapper boxTitle="Business Details (Company Details)">
        <Box component="form" sx={{ mt: 3 }} onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                required
                fullWidth
                id="supplier-gstin"
                label="Supplier GSTIN"
                name="supplierGstin"
                variant="outlined"
               
                value={formValues.supplierGstin}
             
              
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                // required
                fullWidth
                id="trade-name"
                label="Trade Name*"
                name="tradeName"
                value={formValues.tradeName}
                onChange={handleInputChange}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: isClearClicked && formValues.tradeName === '' ? 'red' : undefined, // Conditional border color
                    },
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
            <TextField
    fullWidth
    select
    id="entity-type"
    label="Entity Type*"
    name="entitytype"
    value={formValues.entitytype}
    onChange={handleInputChange}
    sx={{
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: isClearClicked && formValues.entitytype === '' ? 'red' : undefined, // Conditional border color
        },
      },
    }}
  >
    {entityTypes.map((type, index) => (
      <MenuItem key={index} value={type}>
        {type}
      </MenuItem>
    ))}
  </TextField>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                id="phone"
                label="Phone"
                name="phoneNumber"
                value={formValues.phoneNumber}
                onChange={handlePhoneChange}
                inputProps={{ maxLength: 10 }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: isClearClicked && !formValues.phoneNumber ? 'red' : undefined, // Conditional border color
                    },
                  },
                }}
    
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                required
                fullWidth
                // disabled
                id="legal-name"
                label="Legal Name"
                name="legalName"
                value={formValues.legalName}
                // onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                required
                fullWidth
                id="supplier-address1"
                label="Supplier Address 1"
                name="supplierAddress1"
                value={formValues.supplierAddress1}
                onChange={handleInputChange}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: isClearClicked && !formValues.supplierAddress1 ? 'red' : undefined, // Conditional border color
                    },
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                id="supplier-address2"
                label="Supplier Address 2"
                name="supplierAddress2"
                value={formValues.supplierAddress2}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                // required
                fullWidth
                id="supplier-location"
                label="Supplier Location*"
                name="supplierLocation"
                value={formValues.supplierLocation}
                onChange={handleSupplierlocation}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: isClearClicked && formValues.supplierLocation === '' ? 'red' : undefined,
                    },
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                // required
                fullWidth
                id="pin-code"
                label="Pin Code*"
                name="pinCode"
                value={formValues.pinCode}
                onChange={handlePinChange}
                sx={{
                  '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: isClearClicked && formValues.pinCode === '' ? 'red' : undefined,
                    },
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                id="email-id"
                label="Email ID"
                name="emailId"
                type="email"
                // disabled
                value={formValues.emailId}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth >
                <InputLabel id="state-label">State</InputLabel>
                <Select
                  labelId="state-label"
                  // required
                  id="state"
                  name="state"
                  value={formValues.state || ''}
                  onChange={handleInputChange}
                  label="State"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: isClearClicked && !formValues.state ? 'red' : undefined, 
                      },
                    },
                  }}
                >
                  {states.map((state) => (
                    <MenuItem key={state.name} value={state.name}>
                      {state.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <input
                accept=".jpg,.jpeg,.png,.pdf"
                id="upload-image"
                type="file"
                style={{ display: 'none' }}
                onChange={handleImageUpload}
              />
               <label htmlFor="upload"
                style={{ fontSize: '16px',marginRight:'30px' }}
                >
                
    COMPANY LOGO
  </label>
  <label htmlFor="upload-image">
  <Button
    variant="outlined"
    color="secondary"
    component="span"
    sx={{
      borderColor: 'green', 
      color: 'green', 
      textTransform: 'none', 
      '&:hover': {
        borderColor: 'darkgreen',  
        color: 'darkgreen', 
      },
    }}
  >
    Upload
  </Button>
</label>

              <Button
                variant="outlined"
                color="secondary"
                component="span"
                sx={{
                  borderColor: 'red', 
                  color: 'red', 
                   textTransform: 'none',
                  '&:hover': {
                    borderColor: 'red', 
                    color: 'red', 
                  },
                }}
            
                  onClick={handleRemoveImage}
                    style={{ marginLeft: '20px' }}
                >
                 Remove
                </Button>
              {imagePreview && (
        <div style={{ marginTop: '10px' }}>
          <img
            src={imagePreview}
            alt="Company Logo"
            style={{ maxWidth: '60%', maxHeight: '140px', border: '1px solid #ccc' }}
          />


         <div>
     
       </div>
       </div>
      )}
 <div style={{ fontSize: '10px',color:"#909499" }}>
  <p>Preferred Image Dimensions: 240*240 pixels @ 72 DPI</p>
  <p>Maximum File Size: 1MB</p>
  <p>Format - PDF, JPG, JPEG & PNG</p>
</div>
            </Grid>
            <Grid item xs={12} display="flex" justifyContent="flex-end">
              <Box sx={{ display: 'flex', gap: 2 }}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                >
                  {isEditMode ? 'Update' : 'Add'}
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleClear}
                >
                  Clear
                </Button>
             
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        sx={{ mt: 4 }} 
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }} 
      >
        <Alert onClose={handleSnackbarClose}  severity={snackbarSeverity}   variant="filled" sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
      </BoxWrapper>
      )}
     <BoxWrapper  boxTitle="Company Details"
      enableAddButton={true}
      addButtonLabel={"ADD BANK INFO"}
      addButtonHandlerFn={handleClickOpen}
               
               >
                  <div style={{ maxHeight: '500px', overflowY: 'auto', scrollbarWidth: 'thin' }}>
                 <Table sx={{ tableLayout: 'auto' }}>
                   <TableHead>
                     <TableRow>
                       <TableCell style={{ fontSize: '15px', fontWeight: 'bold' }}>GSTIN</TableCell>
                       <TableCell style={{ fontSize: '15px', fontWeight: 'bold',whiteSpace: 'nowrap',  overflow: 'hidden', textOverflow: 'ellipsis'  }}>LEGAL NAME</TableCell>
                       <TableCell style={{ fontSize: '15px', fontWeight: 'bold',whiteSpace: 'nowrap',  overflow: 'hidden', textOverflow: 'ellipsis'  }}>TRADE NAME</TableCell>
                       <TableCell style={{ fontSize: '15px', fontWeight: 'bold',whiteSpace: 'nowrap',  overflow: 'hidden', textOverflow: 'ellipsis' }}>ADDRESS 1</TableCell>
                       <TableCell style={{ fontSize: '15px', fontWeight: 'bold',whiteSpace: 'nowrap',  overflow: 'hidden', textOverflow: 'ellipsis'  }}>ADDRESS 2</TableCell>
                       <TableCell style={{ fontSize: '15px', fontWeight: 'bold' }}>LOCATION</TableCell>
                       <TableCell style={{ fontSize: '15px', fontWeight: 'bold' }}>STATE</TableCell>
                       <TableCell style={{ fontSize: '15px', fontWeight: 'bold' }}>PINCODE</TableCell>
                       <TableCell style={{ fontSize: '15px', fontWeight: 'bold' }}>EMAIL</TableCell>
                       <TableCell style={{ fontSize: '15px', fontWeight: 'bold' }}>PHONE</TableCell>
                       <TableCell style={{ fontSize: '15px', fontWeight: 'bold' }}>ACTION</TableCell>
                     </TableRow>
                   </TableHead>
                   <TableBody>
                       {supplierData.length > 0 ? (
                         supplierData.map((row) => (
                           <TableRow key={row.id}>
                             <TableCell>{row.supplier_gstin}</TableCell>
                             <TableCell>{row.supplier_legal_name}</TableCell>
                             <TableCell>{row.supplier_trade_name}</TableCell>
                             <TableCell>{row.supplier_address_one}</TableCell>
                             <TableCell>{row.supplier_address_two}</TableCell>
                             <TableCell>{row.supplier_location}</TableCell>
                             <TableCell>{row.supplier_state}</TableCell>
                             <TableCell>{row.supplier_pincode}</TableCell>
                             <TableCell>{row.supplier_email}</TableCell>
                             <TableCell>{row.supplier_phone}</TableCell>
                             <TableCell>
                     <EditIcon 
                       style={{ cursor: 'pointer' }} 
                       sx={{
                         '&:hover': {
                           color: 'blue',  
                         },
                       }}
                       onClick={() => handleEdit(row)} 
                     />
                     <AddIcon
    style={{ cursor: 'pointer' }}  
    sx={{
      '&:hover': {
        color: 'green',  
      },
    }}
    onClick={() => handleAdd(row.id)}  
  />
                   </TableCell>
                           </TableRow>
                         ))
                       ) : (
                         <TableRow>
                           <TableCell colSpan={10}>No data found!</TableCell>
                         </TableRow>
                       )}
                     </TableBody>
                 </Table>
                 </div>
               </BoxWrapper>
               <Dialog open={isDialogOpen} onClose={handlelineClose} fullWidth maxWidth="md">
      <DialogTitle>Add Address Information</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              autoFocus

            margin="dense"
            disabled
              label="Legal Name"
              name="legalName"
              value={formData.legalName}
              // onChange={handlelineInputChange} required
              InputLabelProps={{ shrink: true }} 
            />
           
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              InputLabelProps={{ shrink: true }}
              label="Location"
              margin="dense"
              name="location"
              value={formData.location}
              onChange={handlelineInputChange}
              error={validationErrors.includes('location')}
              helperText={validationErrors.includes('location') ? 'This field is required' : ''}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              margin="dense"
              InputLabelProps={{ shrink: true }}
              label="Pincode"
              name="pincode"
              inputProps={{
                maxLength: 6, 
              }}
              value={formData.pincode}
              onChange={handlelineInputChange}
              error={validationErrors.includes('pincode')}
              helperText={validationErrors.includes('pincode') ? 'This field is required' : ''}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              InputLabelProps={{ shrink: true }}
              label="Address 1"
              name="address1"
              value={formData.address1}
              onChange={handlelineInputChange}
              error={validationErrors.includes('address1')}
              helperText={validationErrors.includes('address1') ? 'This field is required' : ''}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              InputLabelProps={{ shrink: true }}
              label="Address 2"
              name="address2"
              value={formData.address2}
              onChange={handlelineInputChange}

            />
          </Grid>
          <Grid item xs={12} sm={4}>
          <TextField
  InputLabelProps={{ shrink: true }}
  fullWidth
  select
  label="State"
  name="state"
  value={formData.state || ''} 
  onChange={handlelineInputChange}
  error={validationErrors.includes("state")}
  helperText={
    validationErrors.includes("state") ? "This field is required" : ""
  }
>
  {stateschild.map((state, index) => (
    <MenuItem key={index} value={state.name}> {/* Use state.name as value */}
      {state.name} {/* Display the state's name */}
    </MenuItem>
  ))}
</TextField>


          </Grid>
        </Grid>

        <Grid container spacing={2} justifyContent="flex-end" style={{ marginTop: '16px' }}>
          <Grid item>
            <Button variant="contained" color="primary" onClick={() => handleSubmitline(currentRowId)}>
            {isEditModeline ? 'Update' : 'Submit'}
            </Button>
          </Grid>
          <Grid item>
            <Button variant="outlined" color="secondary" onClick={handlelineClose}>
              Cancel
            </Button>
          </Grid>
        </Grid>
        <Box sx={{ maxHeight: '370px', overflowY: 'auto', marginTop: '20px' }}>
        <Table stickyHeader sx={{ tableLayout: 'auto' }}>
      <TableHead>
        <TableRow>
          <TableCell style={{ fontSize: '15px', fontWeight: 'bold' }}>Address One</TableCell>
          <TableCell style={{ fontSize: '15px', fontWeight: 'bold' }}>Address Two</TableCell>
          <TableCell style={{ fontSize: '15px', fontWeight: 'bold' }}>Location</TableCell>
          <TableCell style={{ fontSize: '15px', fontWeight: 'bold' }}>State</TableCell>
          <TableCell style={{ fontSize: '15px', fontWeight: 'bold' }}>Pin Code</TableCell>
          <TableCell style={{ fontSize: '15px', fontWeight: 'bold' }}>Action</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {supplierChildData.length > 0 ? (
          supplierChildData.map((row) => (
            <TableRow key={row.id}>
              <TableCell>{row.supplier_child_address_one}</TableCell>
              <TableCell>{row.supplier_child_address_two}</TableCell>
              <TableCell>{row.supplier_child_location}</TableCell>
              <TableCell>{row.supplier_child_state}</TableCell>
              <TableCell>{row.supplier_child_pincode}</TableCell>
              <TableCell style={{ padding: '8px 16px' }}>
          <EditIcon style={{ cursor: 'pointer' }} 
           sx={{
            '&:hover': {
              color: 'blue', 
            },
          }}
          onClick={() => handleEditline(row)}
           />
          </TableCell>
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={5} align="center">
              No data available
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
    </Box>
      </DialogContent>
    </Dialog>
            

       
        <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Add Bank Information</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
       
            margin="dense"
            label="Bank Name"
            name="bank_name"
            value={bankDetails.bank_name} 
            onChange={handleChange}
            fullWidth
            error={errors.bank_name}
            helperText={errors.bank_name ? "Bank Name is required" : ""}
          />
          <TextField
            margin="dense"
            label="Bank Number"
            name="account_number"
            value={bankDetails.account_number}
            onChange={handleChange}
            fullWidth  
                  error={errors.account_number} 
            helperText={errors.account_number ? "Bank Number is required" : ""}
          />
          <TextField
            margin="dense"
            label="IFSC"
            name="ifsc_code"
            value={bankDetails.ifsc_code}
            onChange={handleIFSCChange}
            fullWidth
            error={errors.ifsc_code} 
            helperText={errors.ifsc_code ? "IFSC Code is required" : ""}
          />
          <TextField
            margin="dense"
            label="Account Holder Name"
            name="account_holder_name"
            value={bankDetails.account_holder_name}
            onChange={handleChange}
            fullWidth
            error={errors.account_holder_name} 
            helperText={errors.account_holder_name ? "Account Holder Name is required" : ""}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleaddBankInfo} color="primary">Submit</Button>
        </DialogActions>
        
      </Dialog>
     
    </div>
  );
}

export default Createcompany;
